

//const { access_token }  = JSON.parse(localStorage.getItem("authUser"));

//const accessToken =
// `Bearer ${access_token}`
//export default accessToken


const storedUser = localStorage.getItem("authUser");

let accessToken = null;

if (storedUser) {
  try {
    const { access_token } = JSON.parse(storedUser) || {};
    accessToken = access_token ? `Bearer ${access_token}` : null;
  } catch (error) {
    console.error("Erreur lors du parsing de authUser:", error);
  }
}

export default accessToken;